// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"6ee9d519","647":"84706cfe","675":"fe5a67da","697":"1f5cf55f","706":"8f897483","791":"53b69e8a","904":"e61d6a1b"}[chunkId] + ".chunk.css";
};